"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = require("../arrays/compact");
const compact_2 = require("../objects/compact");
/*
 * Return the enumerable excluding falsey values.
 *
 * @Param {array | object} obj = The object or array to return.
 *
 * @Example
 *
 * compact(['Pizza', 'Pineapple', null, '', undefined])
 * //=> ['Pizza', 'Pineapple']
 *
 * compact({ pizza: 'Mmm', banana: undefined, salad: null })
 * //=> { pizza: 'Mmm' }
 *
 */
function compact(obj) {
    if (Array.isArray(obj))
        return compact_1.compact(obj);
    return compact_2.compact(obj);
}
exports.compact = compact;
//# sourceMappingURL=compact.js.map